import * as Utils from "./modules/utils";
import * as Header from "./modules/header";
import * as Nav from "./modules/nav";
import * as Parallax from "./modules/parallax";
import * as InlineVideos from "./modules/inline-videos";
import * as LightboxVideos from "./modules/lightbox-videos";
import * as BGVideos from "./modules/bg-videos";
import * as Maps from "./modules/maps";
import * as ContactForm from "./modules/contact-form";

// Setup page load transition
Utils.buildPage();

Header.init();
Nav.init();
InlineVideos.init();
ContactForm.init();

// Setup parallax effect
if (document.querySelector(".js-parallax")) {
    Parallax.init();
}

// Maps
if (document.querySelector(".js-map")) {
    Maps.init();
}

// Initialise Videos (a requirement of the youtube API!)
window.onYouTubeIframeAPIReady = function () {
    LightboxVideos.init();
    BGVideos.init();
};
